__turbopack_context__.v({
  "accordionLayout": "_1YTlTa_accordionLayout",
  "chip": "_1YTlTa_chip",
  "chipContainer": "_1YTlTa_chipContainer",
  "column": "_1YTlTa_column",
  "heading": "_1YTlTa_heading",
  "para": "_1YTlTa_para",
  "root": "_1YTlTa_root" + " " + __turbopack_context__.i(296195)["sectionPadding"],
  "separator": "_1YTlTa_separator",
  "subtitle": "_1YTlTa_subtitle",
  "title": "_1YTlTa_title",
});
